import { ErrorHandler } from '@src/components/ErrorHandler';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import React from 'react';

import { Filters } from './components/Filters';

/**
 * Header
 *
 * @TODO Needs description
 *
 * @param props
 * @returns {Element}
 * @constructor
 */
export function Header() {
  return (
    <ErrorHandler location="src/routes/private/WorkQueue/screens/List/components/Table/components/Header/Header.jsx">
      <Layout.Group alignItems="bottom" alignLayout="left" css={{ height: '100%' }}>
        <Filters />
      </Layout.Group>
    </ErrorHandler>
  );
}
